var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOwler = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    fillRule: "evenodd",
    d: "M12.264 15.57a2.57 2.57 0 0 0 2.299-3.717 1.209 1.209 0 1 1-1.604-1.326A2.573 2.573 0 0 0 9.694 13a2.57 2.57 0 0 0 2.57 2.57",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    stroke: "#22262A",
    strokeWidth: 2.09,
    d: "M18.069 7.78a8 8 0 0 0-.489-.497h.854z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 2.09,
    d: "M17.903 12.89a5.607 5.607 0 1 1-11.214 0 5.607 5.607 0 0 1 11.214 0Z"
  })));
};
export default SvgOwler;